import { Box, Collapse, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  getAllExperimentsOfPatient,
  getExperimentInArea,
  suggestExperiment,
} from "../../../../api/area";
import DownArrow from "../../../../assets/SVG/downArrow";
import CustomizedHook from "../../../project/autocomplatePro";
import { InputCreateProject } from "../../../project/createProjectPop";
import TableLibray from "./tableLibray";

export default function Library({ areaId, moduleId }) {
  const [collapseAz, setCollapseAz] = useState();
  const [expresiment, setExpresiment] = useState();
  const [data, setData] = useState({
    experiment: "",
    description: "",
  });
  const [defData, setDefData] = useState([]);
  const [params] = useSearchParams();
  const [patientId] = useMemo(() => {
    return [params.get("patientId")];
  }, [params]);

  useEffect(() => {
    if (collapseAz) {
      getExperimentInArea()
        .then((x) => {
          setExpresiment(x);
        })
        .catch(() => {});
    }
  }, [collapseAz]);
  useEffect(() => {
    if (moduleId && collapseAz) {
      getAllExperimentsOfPatient(areaId, patientId)
        .then((x) => {
          setDefData(x);
        })
        .catch(() => {});
    }
  }, [moduleId, collapseAz]);
  // console.log(defData);
  return (
    <Box
      // height={"80vh"}
      sx={{
        overflow: "auto",
        "::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      <Box
        onClick={() => setCollapseAz(!collapseAz)}
        bgcolor="#EFF1F7"
        borderRadius={"7px"}
        p="10px"
        display="flex"
        justifyContent={"space-between"}
        alignItems="center"
        mt="20px"
        sx={{ cursor: "pointer" }}
      >
        <Typography color="var(--emr-darkblue)">
          {"فرم نسخه ازمایشگاه"}
        </Typography>
        <DownArrow transform={collapseAz} />
      </Box>
      <Collapse in={collapseAz} timeout="auto">
        <Box mt="-5px" bgcolor="#EFF1F7" p="20px">
          <Box display="flex" width={"80%"} alignItems="end">
            <CustomizedHook
              placeholder={"نام خدمت را انتخاب کنید"}
              label="نام خدمت"
              options={expresiment}
              onChange={(event, newValue) => {
                setData({ ...data, experiment: newValue.key });
              }}
              // value={data?.experiment}
            />
            <InputCreateProject
              placeholder={"علت درخواست را بنوسید"}
              label="علت درخواست"
              value={data?.description}
              onChange={(e) =>
                setData({
                  ...data,
                  description: e.target.value,
                })
              }
            />
            <botton
              style={{
                border: "none",
                backgroundColor: "var(--emr-darkblue)",
                color: "white",
                padding: "9px 40px",
                borderRadius: "10px",
                marginLeft: "10px",
                cursor: "pointer",
                marginRight: "20px",
                zIndex: "1",
                // height: "30px",
              }}
              onClick={() => {
                suggestExperiment(areaId, moduleId, patientId, data)
                  .then(() => {
                    // setDefData([...defData, data]);
                    getAllExperimentsOfPatient(areaId, patientId)
                      .then((x) => {
                        setDefData(x);
                      })
                      .catch(() => {});

                    setData({
                      experiment: "",
                      description: "",
                    });
                  })
                  .catch(() => {});
              }}
            >
              ثبت
            </botton>
          </Box>
          {defData?.length > 0 && (
            <TableLibray
              moduleId={moduleId}
              setRowData={setDefData}
              rowData={defData}
            />
          )}
        </Box>
      </Collapse>
    </Box>
  );
}
